import { GridCell } from '@progress/kendo-react-grid'
import React from 'react'

export class ImageCell extends GridCell {
  public render() {
    return <td>
      <div className="preview-image-container">
          <img src={this.props.dataItem.image_url} className="preview-image" ></img>
      </div>
    </td>
  }
}



// WEBPACK FOOTER //
// ./src/pages/lead-posts/render/image_cell.tsx